// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__138II","dragIcon":"Choice_dragIcon__1oszm","left":"Choice_left__3whKi","input":"Choice_input__1jWlV"};